import httpClient from "@/services/httpClient";
import { server } from "@/services/constants";

export const addAdvanceLog = (data) => {
  return httpClient.post(server.ADVANCE_LOG_URL, data);
};
